export enum OperationalStatus {
  Operational = 'Operational',
  Maintenance = 'Maintenance',
  Decommissioned = 'Decommissioned',
}
